import React, { ReactElement, useState, createContext, useEffect } from 'react';

import { useRouter } from 'next/router';

type ProviderProps = {
    children: ReactElement;
};

enum pages {
    login = 1,
    signup = 2,
    lostPassword = 3,
    emailSentConfirmation = 4,
    newPassword = 5,
    loginConfirmation = 6,
    updatePasswordConfirmation = 7,
}

const Context = createContext({
    pages: pages,
    page: pages.login,
    setPage: null,
    email: '',
    setEmail: null,
    password: '',
    setPassword: null,
    stayConnected: false,
    setStayConnected: null,
    tfaType: null,
    setTfaType: null,
    phone: '',
    setPhone: null,
});
const Consumer = Context.Consumer;

const Provider = ({ children }: ProviderProps) => {
    const [page, setPage] = useState(pages.login);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [stayConnected, setStayConnected] = useState(false);
    const [tfaType, setTfaType] = useState<string>(null);
    const router = useRouter();

    useEffect(() => {
        if (router.query?.action && router.query.action === 'forget-password') {
            setPage(pages.lostPassword);
        }
    }, []);

    return (
        <Context.Provider
            value={{
                page,
                setPage,
                pages,
                email,
                setEmail,
                password,
                setPassword,
                stayConnected,
                setStayConnected,
                phone,
                setPhone,
                tfaType,
                setTfaType,
            }}
        >
            {children}
        </Context.Provider>
    );
};
export default { Provider, Consumer };
